import colors from './themes/base';
export var CTA_TYPE;
(function (CTA_TYPE) {
    CTA_TYPE["PRIMARY"] = "PRIMARY";
    CTA_TYPE["SECONDARY"] = "SECONDARY";
    CTA_TYPE["TERTIARY"] = "TERTIARY";
})(CTA_TYPE || (CTA_TYPE = {}));
export var IMAGE_TYPE;
(function (IMAGE_TYPE) {
    IMAGE_TYPE["ICON"] = "ICON";
    IMAGE_TYPE["IMAGE"] = "IMAGE";
})(IMAGE_TYPE || (IMAGE_TYPE = {}));
export var ICON_SIZE;
(function (ICON_SIZE) {
    ICON_SIZE[ICON_SIZE["DESKTOP_WIDTH"] = 150] = "DESKTOP_WIDTH";
    ICON_SIZE[ICON_SIZE["DESKTOP_HEIGHT"] = 75] = "DESKTOP_HEIGHT";
    ICON_SIZE[ICON_SIZE["MOBILE_WIDTH"] = 133] = "MOBILE_WIDTH";
    ICON_SIZE[ICON_SIZE["MOBILE_HEIGHT"] = 56] = "MOBILE_HEIGHT";
})(ICON_SIZE || (ICON_SIZE = {}));
export var COMPONENT_MARGIN_BOTTOM;
(function (COMPONENT_MARGIN_BOTTOM) {
    COMPONENT_MARGIN_BOTTOM[COMPONENT_MARGIN_BOTTOM["DESKTOP"] = 60] = "DESKTOP";
    COMPONENT_MARGIN_BOTTOM[COMPONENT_MARGIN_BOTTOM["MOBILE"] = 30] = "MOBILE";
})(COMPONENT_MARGIN_BOTTOM || (COMPONENT_MARGIN_BOTTOM = {}));
export var NAV_LOGO;
(function (NAV_LOGO) {
    NAV_LOGO[NAV_LOGO["HEIGHT"] = 54] = "HEIGHT";
    NAV_LOGO[NAV_LOGO["WIDTH"] = 100] = "WIDTH";
    NAV_LOGO[NAV_LOGO["HEIGHT_MOBILE"] = 36] = "HEIGHT_MOBILE";
})(NAV_LOGO || (NAV_LOGO = {}));
export const COLOR_MAPPING_INFOGRAPHIC = {
    0: colors.primaryRed,
    1: colors.tertiaryGreenDark,
    2: colors.secondaryBlue,
    3: colors.tertiaryBlueDark,
    4: colors.greyDarkMedium,
};
export var NAV_HEADER_HT;
(function (NAV_HEADER_HT) {
    NAV_HEADER_HT[NAV_HEADER_HT["DESKTOP"] = 74] = "DESKTOP";
    NAV_HEADER_HT[NAV_HEADER_HT["TABLET"] = 50] = "TABLET";
})(NAV_HEADER_HT || (NAV_HEADER_HT = {}));
export const COLOR_MAPPING_CARDS = {
    0: colors.primaryRed,
    1: colors.tertiaryGreenDark,
    2: colors.greyDark,
    3: colors.tertiaryBlueDark,
};
export const HERO_TITLE_ELEMENT_TYPES = {
    H1: '',
    H2: 'H2',
};
